<template>
  <div class="buttons-group">
    <a :href="link" class="btn btn-sm btn-primary">
      Tickets
      <span class="badge badge-light">{{ params.data.cantidad_tickets }}</span>
    </a>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "ResumenDeudoresActionButtons",
  computed: {
    modo() {
      return this.$store.state.Suspensiones.suspensionesMODO;
    },
    link() {
      return `/#/admin/suspensiones/${this.modo}/${this.params.data.id_cliente}/historial`;
    },
  },
});
</script>

<style scoped></style>
